/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * **EXPERIMENTAL** - This icon is still under development, and may change visually.
 *
 *![ExperimentalPineappleHouseIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABdUlEQVR4nO2Vu0rEUBCGo6Kd+gB2amOjPsZCnMsKZ2eMhRdwH8AXSCNa+AQrCAo2FhaC1oqCCD6CNtopiBcUF1aNHIka1k12k01h4YEhYZjzf0zmPyeO81eWMaYHWA+Q5LBcLnfnKdxln4ilOWQNwpi3Od/3O9sSR5JtYLkDkllg2f0CAMkesM4gywOQbmUGAOltKPqOrNVIB9UwZ9+f2wHcR0TjIjvADrQZAFiPsgOKYpoBiMTLDkDs/bRmHIDkpFCY7kstTOSNA8s+kL62MIOarXWLpbGWxCdoiuscE7QUJC92b6I4swxZV4Qbll3XDCDrQsSSTUKe3ElvMBYAJGuhMx4dx+n4zrOcpeimEg9gvQpP6huAGbY5Y0w/kt6kAFwmdPAzVCC5BtZNIL1IOY9aLCDxQJGsM8sIgI4i6U5SbWoAsJxGZ2Kva2Q9zw2ArKu/akk28uuAdKlBbeUfEOT/iUiOY66AxfpaIF1p7Lg2/g9Z1gencg0EJFBdogAAAABJRU5ErkJggg==)
 */
export const ExperimentalPineappleHouseIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15.27 3.08a1.12 1.12 0 0 1 1.5.47c.28.65.26 1.38.21 1.97a5.37 5.37 0 0 1-1.56 3.29c3.1.1 5.58 2.62 5.58 5.72V22a1 1 0 0 1-1 1h-5.1a.5.5 0 0 1-.5-.5v-5c0-1.34-1.1-2.43-2.44-2.43a2.43 2.43 0 0 0-2.44 2.42v5.01a.5.5 0 0 1-.5.5H4a1 1 0 0 1-1-1v-7.47c0-3.1 2.49-5.63 5.6-5.72a5.32 5.32 0 0 1-1.45-5.04c.15-.6.77-.94 1.36-.78a4.2 4.2 0 0 1 1.63 1.22l.01.02c.05-.28.1-.56.17-.84.26-.92.87-3 2.25-2.21.6.5.85 1.33 1.06 2l.06.2c.07.29.12.56.17.84.38-.44.83-.83 1.41-1.14Zm-6 9.66c0 .93-.76 1.68-1.69 1.68-.93 0-1.69-.75-1.69-1.68 0-.93.76-1.68 1.7-1.68.92 0 1.68.75 1.68 1.68Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
